import { get } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

const GET_TOP_VIOLATIONS_REQUEST = 'GET_TOP_VIOLATIONS_REQUEST';
const GET_TOP_VIOLATIONS_SUCCESS = 'GET_TOP_VIOLATIONS_SUCCESS';
const GET_TOP_VIOLATIONS_ERROR = 'GET_TOP_VIOLATIONS_ERROR';

const initialState = {
	data: null,
	isLoading: false,
	hasError: false,
	error: null,
};

export const fetchBinsWithTopViolations = (sort='numViolations|desc', page=1, perPage=10) => (dispatch, getState) => {
	let state = getState();
	let url = `${API_URL}/api/marketing/top-100-violations-bins?sort=${sort}&page=${page}&per_page=${perPage}`;
	dispatch(getTopViolationsRequest());
	return get({
		dispatch,
		url,
		authToken: state.user.authToken,
		onSuccess: (result) => {
			dispatch(getTopViolationsSuccess(result));
		},
		onError: error => dispatch(getTopViolationsError(error)),
	});
};

export const getTopViolationsRequest = () => ({
	type: GET_TOP_VIOLATIONS_REQUEST,
	payload: {
		data: null,
		isLoading: true,
		hasError: false,
		error: null,
	}
});

export const getTopViolationsSuccess = (data) => ({
	type: GET_TOP_VIOLATIONS_SUCCESS,
	payload: {
		isLoading: false,
		data,
		hasError: false,
		error: null,
	}
});

export const getTopViolationsError = (error) => ({
	type: GET_TOP_VIOLATIONS_ERROR,
	payload: {
		isLoading: false,
		data: null,
		hasError: true,
		error: error,
	}
});

const topViolationsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_TOP_VIOLATIONS_REQUEST:
		case GET_TOP_VIOLATIONS_SUCCESS:
		case GET_TOP_VIOLATIONS_ERROR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default topViolationsReducer;
